/* TESS SHOP — scripts propios (prefijo mt-). Un archivo, vanilla JS. */

document.addEventListener("DOMContentLoaded", function () {
  initReveal();
  initCifras();
  initGaleriaProducto();
  initSelectorVariantes();
  initBarraCompra();
  initDesplegables();
});

/* En el editor de temas, Shopify vuelve a pintar la seccion al tocar un ajuste
   y DOMContentLoaded ya no salta. Reenganchamos solo lo que hace falta. */
document.addEventListener("shopify:section:load", function () {
  initDesplegables();
});

/* Al seleccionar un bloque en el editor, abrimos su fila para que se vea */
document.addEventListener("shopify:block:select", function (evento) {
  var fila = evento.target.closest && evento.target.closest(".mt-desplegable");
  if (fila && !fila.open) {
    var resumen = fila.querySelector(".mt-desplegable__cabecera");
    if (resumen) resumen.click();
  }
});

function prefiereReducirMovimiento() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/* Revela con .mt-visible cualquier .mt-reveal cuando entra en pantalla */
function initReveal() {
  var elementos = document.querySelectorAll(".mt-reveal");
  if (!elementos.length) return;

  if (prefiereReducirMovimiento() || !("IntersectionObserver" in window)) {
    elementos.forEach(function (el) {
      el.classList.add("mt-visible");
    });
    return;
  }

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add("mt-visible");
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
  );

  elementos.forEach(function (el, i) {
    el.style.setProperty("--mt-delay", i % 6);
    observador.observe(el);
  });
}

/* Cuenta hacia arriba cifras con [data-mt-cifra-hasta] al entrar en pantalla */
function initCifras() {
  var cifras = document.querySelectorAll("[data-mt-cifra-hasta]");
  if (!cifras.length) return;

  function animar(el) {
    var hasta = parseFloat(el.getAttribute("data-mt-cifra-hasta")) || 0;
    var decimales = (el.getAttribute("data-mt-cifra-hasta").split(".")[1] || "").length;
    if (prefiereReducirMovimiento()) {
      el.textContent = hasta.toFixed(decimales);
      return;
    }
    var duracion = 1400;
    var inicio = null;
    function paso(marca) {
      if (inicio === null) inicio = marca;
      var progreso = Math.min((marca - inicio) / duracion, 1);
      var valor = hasta * (1 - Math.pow(1 - progreso, 3));
      el.textContent = valor.toFixed(decimales);
      if (progreso < 1) window.requestAnimationFrame(paso);
    }
    window.requestAnimationFrame(paso);
  }

  if (!("IntersectionObserver" in window)) {
    cifras.forEach(animar);
    return;
  }
  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          animar(entrada.target);
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.4 }
  );
  cifras.forEach(function (el) {
    observador.observe(el);
  });
}

/* Galeria de la pagina de producto: clic en miniatura cambia la imagen principal */
function initGaleriaProducto() {
  var principal = document.querySelector("[data-mt-galeria-principal]");
  var miniaturas = document.querySelectorAll("[data-mt-galeria-miniatura]");
  if (!principal || !miniaturas.length) return;

  miniaturas.forEach(function (mini) {
    mini.addEventListener("click", function () {
      var full = mini.getAttribute("data-mt-galeria-miniatura");
      if (!full) return;
      principal.src = full;
      miniaturas.forEach(function (m) {
        m.classList.remove("mt-miniatura-activa");
      });
      mini.classList.add("mt-miniatura-activa");
    });
  });
}

/* Selector de variantes en la pagina de producto */
function initSelectorVariantes() {
  var contenedor = document.querySelector("[data-mt-producto]");
  if (!contenedor) return;

  var datosScript = contenedor.querySelector("[data-mt-variantes-json]");
  var inputId = contenedor.querySelector("[data-mt-input-variante-id]");
  var precioEl = contenedor.querySelector("[data-mt-precio]");
  var precioCompareEl = contenedor.querySelector("[data-mt-precio-comparado]");
  var botonComprar = contenedor.querySelector("[data-mt-boton-comprar]");
  var selects = contenedor.querySelectorAll("[data-mt-opcion]");
  var packOpciones = contenedor.querySelectorAll("[data-mt-pack-op]");
  var packCantidad = contenedor.querySelector("[data-mt-cantidad]");
  var packPrecio2 = contenedor.querySelector("[data-mt-pack-precio-2]");
  var packTachado = contenedor.querySelector("[data-mt-pack-tachado]");
  var packPrecio1 = contenedor.querySelector("[data-mt-pack-precio-1]");
  if (!datosScript || !inputId || !selects.length) return;

  /* La barra fija de abajo vive FUERA de [data-mt-producto] y tiene su propio
     formulario. Aqui la mantenemos en sintonia con lo que elige el cliente. */
  var barraId = document.querySelector("[data-mt-barra-id]");
  var barraCantidad = document.querySelector("[data-mt-barra-cantidad]");
  var barraPrecio = document.querySelector("[data-mt-barra-precio]");
  var barraTachado = document.querySelector("[data-mt-barra-tachado]");
  var barraFoto = document.querySelector("[data-mt-barra-foto]");
  var barraVariante = document.querySelector("[data-mt-barra-variante]");
  var barraBoton = document.querySelector("[data-mt-barra-boton]");

  /* Cuantas unidades hay elegidas ahora mismo (1 o las del pack) */
  var unidadesElegidas = 1;

  var variantes;
  try {
    variantes = JSON.parse(datosScript.textContent);
  } catch (e) {
    return;
  }

  function opcionesSeleccionadas() {
    var vals = [];
    selects.forEach(function (s) {
      vals.push(s.value);
    });
    return vals;
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var variante = variantes.find(function (v) {
      return v.options.every(function (op, i) {
        return op === seleccion[i];
      });
    });
    if (!variante) return;

    inputId.value = variante.id;

    if (variante.featured_image) {
      var principal = document.querySelector("[data-mt-galeria-principal]");
      if (principal && principal.src !== variante.featured_image) {
        principal.src = variante.featured_image;
      }
      var miniaturas = document.querySelectorAll("[data-mt-galeria-miniatura]");
      miniaturas.forEach(function (mini) {
        var coincide = mini.getAttribute("data-mt-galeria-miniatura") === variante.featured_image;
        mini.classList.toggle("mt-miniatura-activa", coincide);
        mini.style.borderColor = coincide ? "var(--mt-color-acento)" : "var(--mt-color-borde)";
      });
    }

    if (precioEl) precioEl.textContent = variante.price_formatted;
    if (packPrecio1) packPrecio1.textContent = variante.price_formatted;
    if (packPrecio2 && variante.pack_price_formatted) packPrecio2.textContent = variante.pack_price_formatted;
    if (packTachado && variante.pack_compare_formatted) packTachado.textContent = variante.pack_compare_formatted;
    if (precioCompareEl) {
      if (variante.compare_at_price_formatted) {
        precioCompareEl.textContent = variante.compare_at_price_formatted;
        precioCompareEl.style.display = "";
      } else {
        precioCompareEl.style.display = "none";
      }
    }
    if (botonComprar) {
      if (variante.available) {
        botonComprar.disabled = false;
        botonComprar.textContent = botonComprar.getAttribute("data-mt-texto-disponible") || botonComprar.textContent;
      } else {
        botonComprar.disabled = true;
        botonComprar.textContent = botonComprar.getAttribute("data-mt-texto-agotado") || "Agotado";
      }
    }

    actualizarBarra(variante, seleccion);
  }

  function actualizarBarra(variante, seleccion) {
    /* Solo hay precio de pack si el selector de pack esta en pantalla. Si el
       cliente sube la cantidad a mano, la barra sigue mostrando precio unitario. */
    var enPack = packOpciones.length > 0 && !!packCantidad && unidadesElegidas > 1;

    if (barraId) barraId.value = variante.id;
    if (barraCantidad) barraCantidad.value = unidadesElegidas;

    if (barraPrecio) {
      barraPrecio.textContent =
        enPack && variante.pack_price_formatted
          ? variante.pack_price_formatted
          : variante.price_formatted;
    }
    if (barraTachado) {
      var tachado = enPack ? variante.pack_compare_formatted : variante.compare_at_price_formatted;
      if (tachado) {
        barraTachado.textContent = tachado;
        barraTachado.style.display = "";
      } else {
        barraTachado.style.display = "none";
      }
    }
    if (barraFoto && variante.featured_image && barraFoto.src !== variante.featured_image) {
      barraFoto.src = variante.featured_image;
    }
    if (barraVariante) {
      var partes = seleccion.slice();
      if (enPack) partes.push("Pack de " + unidadesElegidas);
      barraVariante.textContent = partes.join(" · ");
    }
    if (barraBoton) {
      if (variante.available) {
        barraBoton.disabled = false;
        barraBoton.textContent = barraBoton.getAttribute("data-mt-texto-disponible") || barraBoton.textContent;
      } else {
        barraBoton.disabled = true;
        barraBoton.textContent = barraBoton.getAttribute("data-mt-texto-agotado") || "Agotado";
      }
    }
  }

  /* Tarjetas de 1 unidad / pack: cambian la cantidad que se envia al carrito */
  if (packOpciones.length && packCantidad) {
    packOpciones.forEach(function (op) {
      op.addEventListener("click", function () {
        packCantidad.value = op.getAttribute("data-mt-pack-op") || "1";
        unidadesElegidas = parseInt(packCantidad.value, 10) || 1;
        packOpciones.forEach(function (otra) {
          var activa = otra === op;
          otra.classList.toggle("mt-pack__op--activa", activa);
          otra.setAttribute("aria-pressed", activa ? "true" : "false");
        });
        actualizar();
      });
    });
  }

  /* Sin selector de pack: la barra copia la cantidad que teclee el cliente */
  var cantidadNumerica = contenedor.querySelector('input[type="number"][name="quantity"]');
  if (cantidadNumerica) {
    cantidadNumerica.addEventListener("input", function () {
      unidadesElegidas = parseInt(cantidadNumerica.value, 10) || 1;
      actualizar();
    });
  }

  selects.forEach(function (s) {
    s.addEventListener("change", actualizar);
  });
  actualizar();
}

/* Barra de compra fija: aparece cuando el boton grande sale de pantalla.
   Comprobacion directa en cada scroll, NO IntersectionObserver: el observador
   solo avisa al cruzar el borde y si la pagina carga con el boton justo al
   filo (lo que pasa en pantallas de ordenador) puede no dispararse nunca. */
function initBarraCompra() {
  var barra = document.querySelector("[data-mt-barra]");
  var referencia = document.querySelector("[data-mt-boton-comprar]");
  if (!barra || !referencia) return;

  function revisar() {
    var caja = referencia.getBoundingClientRect();
    /* El boton grande ha quedado por encima de la pantalla: el cliente ya ha
       bajado y se ha quedado sin boton a la vista. */
    var toca = caja.bottom < 0;
    barra.classList.toggle("mt-barra--visible", toca);
    document.body.classList.toggle("mt-con-barra", toca);
  }

  window.addEventListener("scroll", revisar, { passive: true });
  window.addEventListener("resize", revisar);
  window.addEventListener("load", revisar);
  revisar();
}

/* Filas desplegables. El HTML usa <details>, asi que sin JavaScript siguen
   abriendo y cerrando solas: aqui solo anadimos la animacion de altura y,
   si el ajuste lo pide, que solo pueda haber una fila abierta a la vez.
   Se marca cada grupo con data-mt-listo para no duplicar los listeners
   cuando el editor de temas vuelve a lanzar esta funcion. */
function initDesplegables() {
  var grupos = document.querySelectorAll("[data-mt-desplegables]:not([data-mt-listo])");
  if (!grupos.length) return;

  grupos.forEach(function (grupo) {
    grupo.setAttribute("data-mt-listo", "");
    var soloUna = grupo.hasAttribute("data-mt-solo-una");
    var filas = Array.prototype.slice.call(grupo.querySelectorAll(".mt-desplegable"));

    filas.forEach(function (fila) {
      var resumen = fila.querySelector(".mt-desplegable__cabecera");
      var cuerpo = fila.querySelector(".mt-desplegable__cuerpo");
      if (!resumen || !cuerpo) return;

      var animacion = null;

      function sinAnimacion() {
        return prefiereReducirMovimiento() || typeof cuerpo.animate !== "function";
      }

      function animar(desde, hasta, alTerminar) {
        if (animacion) animacion.cancel();
        animacion = cuerpo.animate(
          { height: [desde + "px", hasta + "px"] },
          { duration: 260, easing: "cubic-bezier(0.22, 1, 0.36, 1)" }
        );
        animacion.onfinish = function () {
          animacion = null;
          if (alTerminar) alTerminar();
          cuerpo.style.height = "";
        };
        animacion.oncancel = function () {
          animacion = null;
          cuerpo.style.height = "";
        };
      }

      function abrir() {
        fila.open = true;
        if (sinAnimacion()) return;
        animar(0, cuerpo.scrollHeight);
      }

      function cerrar() {
        if (sinAnimacion()) {
          fila.open = false;
          cuerpo.style.height = "";
          return;
        }
        var alto = cuerpo.offsetHeight;
        animar(alto, 0, function () {
          fila.open = false;
        });
        /* Dejamos ya fijada la altura final. Mientras la animacion corre manda
           ella, y al acabar entra este 0 en vez de un fotograma a plena altura. */
        cuerpo.style.height = "0px";
      }

      /* Nos hacemos cargo del abrir/cerrar: sin preventDefault el navegador
         cambiaria `open` al instante y no habria nada que animar. */
      resumen.addEventListener("click", function (evento) {
        evento.preventDefault();
        if (fila.open) {
          cerrar();
          return;
        }
        if (soloUna) {
          filas.forEach(function (otra) {
            if (otra !== fila && otra.open && otra.mtCerrar) otra.mtCerrar();
          });
        }
        abrir();
      });

      fila.mtCerrar = cerrar;
    });
  });
}
